$(document).ready(function(){
    var $sidebarMenu = $('.sidebar-menu');
    $sidebarMenu.on('click', '.dropdown > a:not(.arrow)', function(e){
        e.preventDefault();
        var $this = $(this).parent();
        $this.toggleClass('opened');
        if ($this.hasClass('opened')){
            $this.find('>ul').slideDown();
            $this.siblings().removeClass('opened').find('>ul').slideUp();
        } else {
            $this.removeClass('opened').find('>ul').slideUp();
        }
    });

    $('.mobile-menu-toggle').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('opened');
        if ($(this).hasClass('opened')){
            $('body').addClass('no-scroll');
            $('.sidebar').addClass('show')
            $('.overlay').fadeIn();
        } else {
            $('body').removeClass('no-scroll');
            $('.sidebar').removeClass('show');
            $('.overlay').fadeOut();
        }
    })
    $('.overlay, .close-sidebar').on('click', function (e) {
        e.preventDefault();
        $('.sidebar').removeClass('show');
        $('.overlay').fadeOut();
        $('.mobile-menu-toggle').removeClass('opened');
        $('body').removeClass('no-scroll');
    });

    /*Sidebar on hover second level menu*/
    function enableHoverSubmenu() {
        $('.sidebar-menu .arrow').off('mouseenter mouseleave').each(function() {
            var $item = $(this);
            var $submenu = $item.children('ul');

            // ensure submenu is hidden and has the right CSS positioning
            $submenu.css({
                display: 'none',
                position: 'fixed',
                zIndex: 1000
            });

            $item
                .on('mouseenter', function() {
                    var offs = $item.offset();
                    $submenu
                        .css({
                            top:  offs.top + 'px',
                            left: (offs.left + $item.outerWidth()) + 'px'
                        })
                        .stop(true, true)
                        .fadeIn(300);
                })
                .on('mouseleave', function() {
                    $submenu.stop(true, true).fadeOut(300);
                });
        });
    }
    function enableClickSubmenu() {
        $('.sidebar-menu .arrow').off('mouseenter mouseleave click');
        $('.sidebar-menu .arrow > a').off('click').on('click', function (e) {
            e.preventDefault();
            var $submenu = $(this).next('ul');
            $submenu.stop(true, true).slideToggle();
        });
    }

    function handleResize() {
        if ($(window).width() < 992) {
            enableClickSubmenu();
        } else {
            enableHoverSubmenu();
        }
    }
    handleResize();
    $(window).on('resize', function () {
        handleResize();
    });
});
